/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExperienceAndPrice } from './';
import {
    ExperienceAndPriceFromJSON,
    ExperienceAndPriceFromJSONTyped,
    ExperienceAndPriceToJSON,
} from './';
import type { FreelancerProfile } from './';
import {
    FreelancerProfileFromJSON,
    FreelancerProfileFromJSONTyped,
    FreelancerProfileToJSON,
} from './';
import type { FreelancersPerArea } from './';
import {
    FreelancersPerAreaFromJSON,
    FreelancersPerAreaFromJSONTyped,
    FreelancersPerAreaToJSON,
} from './';
import type { FreelancersPerGeneration } from './';
import {
    FreelancersPerGenerationFromJSON,
    FreelancersPerGenerationFromJSONTyped,
    FreelancersPerGenerationToJSON,
} from './';
import type { JobAndPrice } from './';
import {
    JobAndPriceFromJSON,
    JobAndPriceFromJSONTyped,
    JobAndPriceToJSON,
} from './';
import type { Nav } from './';
import {
    NavFromJSON,
    NavFromJSONTyped,
    NavToJSON,
} from './';
import type { Range } from './';
import {
    RangeFromJSON,
    RangeFromJSONTyped,
    RangeToJSON,
} from './';

/**
 * 
 * @export
 * @interface JobBarometer
 */
export interface JobBarometer {
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    query?: string;
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    humanId?: string;
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    familyId?: string;
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    familyBannerName?: string;
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    jobId?: string;
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    metadescription?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobBarometer
     */
    localities?: Array<string>;
    /**
     * 
     * @type {Array<Nav>}
     * @memberof JobBarometer
     */
    nav?: Array<Nav>;
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    jobLabelPlural?: string;
    /**
     * 
     * @type {number}
     * @memberof JobBarometer
     */
    averagePrice: number;
    /**
     * 
     * @type {Array<ExperienceAndPrice>}
     * @memberof JobBarometer
     */
    experienceAndPrices: Array<ExperienceAndPrice>;
    /**
     * 
     * @type {Array<JobAndPrice>}
     * @memberof JobBarometer
     */
    jobAndPrices: Array<JobAndPrice>;
    /**
     * 
     * @type {number}
     * @memberof JobBarometer
     */
    highestPrice: number;
    /**
     * 
     * @type {number}
     * @memberof JobBarometer
     */
    shareOfMen?: number;
    /**
     * 
     * @type {number}
     * @memberof JobBarometer
     */
    shareOfWomen?: number;
    /**
     * 
     * @type {number}
     * @memberof JobBarometer
     */
    nbFreelancers: number;
    /**
     * 
     * @type {Array<FreelancersPerGeneration>}
     * @memberof JobBarometer
     */
    freelancersPerGenerations?: Array<FreelancersPerGeneration>;
    /**
     * 
     * @type {string}
     * @memberof JobBarometer
     */
    mapArea?: string;
    /**
     * 
     * @type {Array<FreelancersPerArea>}
     * @memberof JobBarometer
     */
    freelancersPerAreas: Array<FreelancersPerArea>;
    /**
     * 
     * @type {Array<Range>}
     * @memberof JobBarometer
     */
    areaSizeRange: Array<Range>;
    /**
     * 
     * @type {Array<FreelancerProfile>}
     * @memberof JobBarometer
     */
    results: Array<FreelancerProfile>;
}

/**
 * Check if a given object implements the JobBarometer interface.
 */
export function instanceOfJobBarometer(value: object): value is JobBarometer {
    if (!('averagePrice' in value) || value['averagePrice'] === undefined) return false;
    if (!('experienceAndPrices' in value) || value['experienceAndPrices'] === undefined) return false;
    if (!('jobAndPrices' in value) || value['jobAndPrices'] === undefined) return false;
    if (!('highestPrice' in value) || value['highestPrice'] === undefined) return false;
    if (!('nbFreelancers' in value) || value['nbFreelancers'] === undefined) return false;
    if (!('freelancersPerAreas' in value) || value['freelancersPerAreas'] === undefined) return false;
    if (!('areaSizeRange' in value) || value['areaSizeRange'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function JobBarometerFromJSON(json: any): JobBarometer {
    return JobBarometerFromJSONTyped(json, false);
}

export function JobBarometerFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobBarometer {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'] == null ? undefined : json['query'],
        'humanId': json['humanId'] == null ? undefined : json['humanId'],
        'familyId': json['familyId'] == null ? undefined : json['familyId'],
        'familyBannerName': json['familyBannerName'] == null ? undefined : json['familyBannerName'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'country': json['country'] == null ? undefined : json['country'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'title': json['title'] == null ? undefined : json['title'],
        'metadescription': json['metadescription'] == null ? undefined : json['metadescription'],
        'localities': json['localities'] == null ? undefined : json['localities'],
        'nav': json['nav'] == null ? undefined : ((json['nav'] as Array<any>).map(NavFromJSON)),
        'jobLabelPlural': json['jobLabelPlural'] == null ? undefined : json['jobLabelPlural'],
        'averagePrice': json['averagePrice'],
        'experienceAndPrices': ((json['experienceAndPrices'] as Array<any>).map(ExperienceAndPriceFromJSON)),
        'jobAndPrices': ((json['jobAndPrices'] as Array<any>).map(JobAndPriceFromJSON)),
        'highestPrice': json['highestPrice'],
        'shareOfMen': json['shareOfMen'] == null ? undefined : json['shareOfMen'],
        'shareOfWomen': json['shareOfWomen'] == null ? undefined : json['shareOfWomen'],
        'nbFreelancers': json['nbFreelancers'],
        'freelancersPerGenerations': json['freelancersPerGenerations'] == null ? undefined : ((json['freelancersPerGenerations'] as Array<any>).map(FreelancersPerGenerationFromJSON)),
        'mapArea': json['mapArea'] == null ? undefined : json['mapArea'],
        'freelancersPerAreas': ((json['freelancersPerAreas'] as Array<any>).map(FreelancersPerAreaFromJSON)),
        'areaSizeRange': ((json['areaSizeRange'] as Array<any>).map(RangeFromJSON)),
        'results': ((json['results'] as Array<any>).map(FreelancerProfileFromJSON)),
    };
}

export function JobBarometerToJSON(value?: JobBarometer | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'query': value['query'],
        'humanId': value['humanId'],
        'familyId': value['familyId'],
        'familyBannerName': value['familyBannerName'],
        'categoryId': value['categoryId'],
        'jobId': value['jobId'],
        'country': value['country'],
        'countryCode': value['countryCode'],
        'title': value['title'],
        'metadescription': value['metadescription'],
        'localities': value['localities'],
        'nav': value['nav'] == null ? undefined : ((value['nav'] as Array<any>).map((v) => NavToJSON(v))),
        'jobLabelPlural': value['jobLabelPlural'],
        'averagePrice': value['averagePrice'],
        'experienceAndPrices': ((value['experienceAndPrices'] as Array<any>).map((v) => ExperienceAndPriceToJSON(v))),
        'jobAndPrices': ((value['jobAndPrices'] as Array<any>).map((v) => JobAndPriceToJSON(v))),
        'highestPrice': value['highestPrice'],
        'shareOfMen': value['shareOfMen'],
        'shareOfWomen': value['shareOfWomen'],
        'nbFreelancers': value['nbFreelancers'],
        'freelancersPerGenerations': value['freelancersPerGenerations'] == null ? undefined : ((value['freelancersPerGenerations'] as Array<any>).map((v) => FreelancersPerGenerationToJSON(v))),
        'mapArea': value['mapArea'],
        'freelancersPerAreas': ((value['freelancersPerAreas'] as Array<any>).map((v) => FreelancersPerAreaToJSON(v))),
        'areaSizeRange': ((value['areaSizeRange'] as Array<any>).map((v) => RangeToJSON(v))),
        'results': ((value['results'] as Array<any>).map((v) => FreelancerProfileToJSON(v))),
    };
}

